module.exports = __webpack_public_path__ + "static/media/taglinesImage.6db80987.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/taglinesImage.png
// module id = 1002
// module chunks = 0